<template>
  <div>
    <template v-if="landownerReport.harvest || landownerReport.nonHarvest">
      <ul class="mb-0">
        <li class="mb-2">
          A Written Management Plan
          <strong>WAS {{landownerReport.managementPlan ? '' : 'NOT '}}</strong>
          developed for this property.
        </li>
        <li class="mb-2">
          A Maine Licensed Forester
          <strong>DID {{licensedForester ? '' : 'NOT '}}</strong>
          supervise this harvest.
        </li>
      </ul>
      <DetailRow
        v-if="licensedForester"
        label="Licensed Forester / License Number"
        :value="licensedForesterValue"
      />
      <hr class="border-dark">
      <h5>Operator/Harvester Contact</h5>
      <ContactDetails
        v-if="!landownerReport.operatorChanged"
        :contact="notification.operatorContact"
        :disableRemove="true"
      />
      <template v-else>
        <DetailRow
          label="Name"
          :value="landownerReport.operatorName"
        />
        <AddressDetails
          class="mb-2"
          title="Address"
          :address="landownerReport.operatorAddress"
        />
      </template>
      <hr class="border-dark">
      <h5>Broker(s)/Exporter(s)</h5>
      <ul class="mb-0">
        <li class="mb-2">
          Forest products <strong>WERE {{landownerReport.exported ? '' : 'NOT '}}</strong>
          exported outside of Maine or sold to a broker for export.
        </li>
      </ul>
      <b-list-group v-if="landownerReport.exported">
        <b-list-group-item
          v-for="exporter in landownerReport.exporters"
          :key="exporter.id"
          class="border-dark"
        >
          <b-row>
            <b-col cols="12" lg="4">
              <DetailRow
                containerMargin="mb-0"
                label="Name"
                :value="exporter.name"
              />
            </b-col>
            <b-col>
              <AddressDetails
                title="Address"
                :address="exporter.address"
              />
            </b-col>
          </b-row>
        </b-list-group-item>
      </b-list-group>
    </template>
    <p v-else>
      Harvest Involvement details are not required because no harvesting activity was indicated for
      this reporting year.
    </p>
    <b-alert v-if="landownerReport.editorCommentInvolvement" variant="warning" show class="mt-3">
      <strong>Editor's Comment:</strong>
      <p class="mb-0 mt-1">{{ landownerReport.editorCommentInvolvement }}</p>
    </b-alert>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AddressDetails from '@/components/account/AddressDetails.vue';
import ContactDetails from '@/components/account/ContactDetails.vue';
import DetailRow from '@/components/DetailRow.vue';

export default {
  name: 'InvolvementDetails',
  components: {
    AddressDetails,
    ContactDetails,
    DetailRow,
  },
  computed: {
    ...mapState('Notification', {
      notification: state => state.notification,
    }),
    ...mapState('LandownerReport', {
      landownerReport: state => state.landownerReport,
    }),
    notificationLicensedForesterAndNotChanged() {
      return this.notification.licensedForesterContact
        && !this.landownerReport.licensedForesterChanged;
    },
    licensedForester() {
      const lfChanged = this.landownerReport.licensedForesterChanged
        && this.landownerReport.anotherLicensedForester;
      return this.notificationLicensedForesterAndNotChanged
        || lfChanged
        || this.landownerReport.licensedForesterAdded;
    },
    licensedForesterValue() {
      if (this.notificationLicensedForesterAndNotChanged) {
        return `${this.notification.licensedForesterContact.firstName} ${this.notification.licensedForesterContact.lastName} / ${this.notification.licensedForesterContact.licensedForesterId}`;
      }
      return `${this.landownerReport.licensedForesterName} / ${this.landownerReport.licenseNumber}`;
    },
  },
};
</script>
